import React, { useRef, useEffect } from 'react';

const CardHeader = (props) => {
    const styleRef = useRef(null);

    const BackgroundColor = {
        darkGreenBlue: "#004144",
        mintGreenLight: "#E9F8EE",
        darkIndigo: "#1E4345",
        lightGray: "#E8E8E8"
    }

    useEffect(() => {
        styleRef.current.style.background = BackgroundColor[props.background ? props.background: "darkGreenBlue"];
     });

    return (
        <div className="card-header" ref={styleRef}>
            <div className="heading d-flex flex-column">
                <b className={`${props.color ? props.color: "colour-Gray91"} font-weight-heading-xl font-xl medium-bold`}>{props.title ? props.title.title: ''}</b>
                <span className={`${props.color ? props.color: "colour-Gray91"} font-x-large`}>nbn™ {props.plan.planDownloadSpeed ? props.plan.planDownloadSpeed: ''}</span>                
            </div>
        </div>
    )
}

export default CardHeader;


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/card/CardHeader.js